import { createContext, useContext, useState } from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState({ open: false });

  const confirm = ({
    title = 'Are you sure?',
    description = 'This action cannot be undone.',
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    variant = 'default', // 'default' | 'danger'
  } = {}) =>
    new Promise((resolve) => {
      setState({ open: true, title, description, confirmLabel, cancelLabel, variant, resolve });
    });

  const close = (result) => {
    if (state.resolve) state.resolve(result);
    setState({ open: false });
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      <AlertDialog open={state.open} onOpenChange={(v) => { if (!v) close(false); }}>
        <AlertDialogContent data-testid="confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>{state.title}</AlertDialogTitle>
            <AlertDialogDescription>{state.description}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => close(false)} data-testid="confirm-dialog-cancel-button">{state.cancelLabel}</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => close(true)}
              data-testid="confirm-dialog-confirm-button"
              className={state.variant === 'danger' ? 'bg-rose-500 hover:bg-rose-600 text-white' : ''}
            >
              {state.confirmLabel}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmContext.Provider>
  );
}

export const useConfirm = () => {
  const ctx = useContext(ConfirmContext);
  return ctx?.confirm || (async () => true);
};
